import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useGetBackfillStatusQuery as useBaseBackfillStatusQuery } from '../services/backfillApi';

export const useGetBackfillStatusQuery = (pollingInterval = 30000) => {
  const user = useSelector((state: RootState) => state.auth.user);

  return useBaseBackfillStatusQuery(undefined, {
    pollingInterval,
    skip: !user?.companyID || !user?.companyName,
  });
};
